import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';
import { useTheme } from 'styled-components';

import { Translate } from '@core/constant';
import { EIcon, ESize, InputSize, ThemeProps } from '@core/type';

import { ButtonIcon } from '../../button';
import { Box } from '../../layout';
import { InputTextControl } from './InputTextControl';
import { InputPasswordContainerProps } from './interface-form-input';

export const InputPassword = ({
  translate,
  ariaLabel,
  name,
  size,
  ...inputProps
}: InputPasswordContainerProps): JSX.Element => {
  const { t: tAria } = useTranslation(Translate.common.ARIA);
  const { t: tForm } = useTranslation(Translate.common.FORM);

  const [isVisible, setIsVisible] = useState<boolean>(false);

  const {
    structure: {
      input: {
        defaultSize,
        text: {
          wrapper: { size: wrapperSize },
        },
      },
    },
  } = useTheme() as ThemeProps;

  const inputSize: InputSize = size || defaultSize;

  return (
    <Box position={'relative'} width={'100%'}>
      <InputTextControl
        withRightSideIcon
        name={name || 'password'}
        aria-label={ariaLabel || tAria('passwordInput')}
        label={translate ? tForm(translate) : tForm('password.title')}
        type={isVisible ? 'text' : 'password'}
        size={inputSize}
        {...inputProps}
      />
      <Box
        position={'absolute'}
        height={'24px'}
        right={'16px'}
        top={`calc(${wrapperSize[inputSize].height} / 2 - 12px)`}
      >
        <ButtonIcon
          role={'button'}
          type={'button'}
          onClick={() => setIsVisible((prev) => !prev)}
          iconProps={{
            size: ESize.MD,
            type: isVisible ? EIcon.EYE_CLOSED : EIcon.EYE,
          }}
        />
      </Box>
    </Box>
  );
};
